import { Link } from 'react-router-dom';
import { ROUTER_PATHS } from '@/app/routes';
import logoUrl from '@/shared/ui/logo.svg?url';

export function HeaderLogo() {
	return (
		<Link to={ROUTER_PATHS.root.getLink()} className="flex items-center gap-4 hover:opacity-80 transition-opacity">
			{/* Logo Icon */}
			<div className="w-[34px] h-[30px] flex-shrink-0">
				<img src={logoUrl} alt="FabControl Logo" className="w-full h-full object-contain" />
			</div>

			{/* Brand Text */}
			<div className="flex flex-col">
				<h1 className="text-2xl font-bold leading-8 text-brand-navy">FabControl</h1>
				<p className="text-xs text-gray-600 leading-4">Production Management System</p>
			</div>
		</Link>
	);
}
